







































































































import Vue from 'vue';
import _ from 'lodash';
import store from '@/store';
import router from '@/router';
import { mapState, mapGetters } from 'vuex';
import TeamCreate from '@/components/team/team-create.vue';
import TeamSelector from '@/components/common/team-selector.vue';
import TeamSummary from '@/components/team/team-summary.vue';
import TeamViewpoints from '@/components/team/team-viewpoints.vue';
import TeamResults from '@/components/team/teams-results.vue';
import TeamCardMenu from '@/components/team/teams-card-menu.vue';
import TeamInviteButton from '@/components/team/team-invite-button.vue';
import TeamViewpointButton from '@/components/team/team-viewpoint-button.vue';
import { ViewpointDao } from "@/api/ViewpointDao";

var apiDao: ViewpointDao = new ViewpointDao();

export default Vue.extend({

  name: 'TeamPage',

  components: {
    'team-create': TeamCreate,
    'team-results': TeamResults,
    'team-card-menu': TeamCardMenu,
    'team-invite-button': TeamInviteButton,
    'team-viewpoint-button': TeamViewpointButton,
    TeamSummary,
    TeamViewpoints,
    TeamSelector,
  },

  props: {
  },

  data() {
    return {
      team: {} as any,
      selectedTeamId: this.$route.params.teamId as string,
      teams: this.$store.getters.getVpGroups,
      teamViewpoint: {} as any, 
      teamViewpointResponse: {} as any, 
      viewpoints: [] as any,
      dialog: false,
      drawer: false,
      deleteDialog: false,
      editDialog: false,
      valid: false,
      vp_updating: false,
      message: 'Your team is being created ...',
      showMessage: false,
      formSubject: '' as any,
      ruleSubject: [
        (v: any) => !!v || '"Team Name" is required',
        (v: any) =>
          (v && v.length <= 100) ||
          '"Team Name" must be less than 100 characters'
      ],
      formBody: '' as any,
      ruleBody: [
        // (v: any) => !!v || '"Description" is required',
        (v: any) =>
          ( !v || (v.length <= 500)) ||
          '"Description" must be less than 500 characters'
      ],
    };
  },

  created() {
    console.log('[ TeamPage created() ]');
    // this.teams = this.getVpGroupsList;
    if (!this.getIsLoggedIn) {
      router.push('/mls');
    }
    if (!this.selectedTeamId) {
      const recentTeamId = this.getVpGroupsList[0];
      if (recentTeamId) {
        router.push('/team/'+recentTeamId);
      }
    }
    this.loadTeam();
  },

  mounted() {
  },

  watch: {
    selectedTeamId(newVal, oldVal) {
      console.log('Watch > Store > selectedTeamId');
      this.loadTeam();
    },
    getVpGroupsList(newVal, oldVal) {
      console.log('Watch > Store > getVpGroupsList');
      if (!this.selectedTeamId) {
        const recentTeamId = this.getVpGroupsList[0];
        if (recentTeamId) {
          router.push('/team/'+recentTeamId);
        }
      }
    },
    getVpGroups(newVal, oldVal) {
      console.log('Watch > Store > getVpGroups');
      this.teams = newVal;
      this.loadTeam();
    },
    getVpInstances(newVal, oldVal) {
      console.log('Watch > Store > getVpInstances');
      this.loadTeam();
    },
  },

  computed: {
    
     ...mapGetters([
      'getFavourites',
      'getIsLoggedIn',
      'getInstanceId',
      'getVpInstances',
      'getVpInstancesCount',
      'getVpInstanceList',
      'getVpInstanceListCount',
      'getVpGroups',
      'getVpGroupsCount',
      'getVpGroupsList',
      'getVpGroupsListCount',
      'getVpGroupInstances',
      'getVpGroupInstancesCount',
      'getVpGroupInstancesList',
      'getVpGroupInstancesListCount'
    ]),

    isUpdating(): any {
      return this.$store.getters.getVpUpdating;
    },
   
    isLoggedIn(): any {
      return this.$store.getters.getIsLoggedIn;
    },

    formatDate(): string {
      let newDate: Date = new Date
      let options: object = { year: 'numeric', month: 'long', day: 'numeric' };
      let locale: string = 'en-US';
      return newDate.toLocaleDateString(locale, options);
    },

    teamName(): string {
      if (Object.keys(this.team).length){
        let name: string  = ( this.team.name ? String(this.team.name) : '' );
        let res: string = ( name.length > 8 ? String(name.substring(0, 8)) + '...' : String(name) );
        return res;
      } else {
        return '';
      }
    },

    numberOfTeamMembers(): number {
      return this.team.users.length + this.team.adminUsers.length;
    },

    numberOfSharedViewpoints(): number {
      return this.team.viewpoints.length;
    },

    isValidEdit(): boolean {
      return (this.valid && !!this.formSubject);
    },
    
    isTeamLoaded(): boolean {
      return !!Object.keys(this.team).length;
    },

  },

  methods: {

    loadTeam() {
      this.viewpoints = this.getVpInstances;
      if (this.getVpGroupsList.length) {
        this.team = _.filter(this.getVpGroups, {'teamId': this.selectedTeamId})[0]
      }
      if (!this.team) {
        this.team = {};
      }
      console.log('loadTeam() > team:');
      console.log(this.team);
    },

    teamSelected(teamId: any = '') {
      console.log(teamId);
      if (!teamId) { teamId = ''; }
      router.push('/team/'+teamId);
      this.selectedTeamId = teamId;
    },

    newTeam() {
      store.dispatch('createTeam');
    },
    
    deleteTeamDialog(team: object) {
      this.deleteDialog = true;
      console.log('vp-team-card > deleteTeamDialog():');
      console.log(team);
    },

    deleteTeam(team: object) {
      console.log('vp-team-card > teamDeleteConfirm():');
      console.log(team);
      store.dispatch("deleteTeam", team);
      this.deleteDialog = false;
    },

    editTeamDialog(team: any) {
      this.editDialog = true;
      if (team.name) { this.formSubject = team.name; }
      if (team.description) { this.formBody = team.description; }
      console.log('vp-team-card > editTeamDialog():');
      console.log(team);
    },

    editTeam(team: any) {
      if (this.formSubject ) {
        let payload: any = _.cloneDeep(team);
        payload.name = this.formSubject;
        // TODO - FIX: Team Description not allowing an empty edit
        if (this.formBody.length) {
          payload.description = this.formBody;
        } else {
          payload.description = '';
        }
        console.log('vp-team-card > teamEditConfirm():');
        console.log(payload);
        store.dispatch("editTeam", payload);
      }
      this.editDialog = false;
    },
    
  },


});

